import { AlertTriangle, CheckCircle2, Clock, XCircle } from "lucide-react";

import { ColocaStatusPill } from "@/shared/components/data-display/ColocaStatusPill";
import useTranslations from "@/shared/lang/useTranslations";

import type { WalletDebit } from "../types/walletDebits.types";
import { isStaleReservation } from "../utils/walletDebit";

/** Pending (overdue after a day), sent or cancelled. */
export function WalletDebitStatusPill({ debit }: { debit: Pick<WalletDebit, "status" | "created_at"> }) {
  const { t } = useTranslations("walletDebits");
  if (debit.status === "SENT") {
    return (
      <ColocaStatusPill variant="success" icon={CheckCircle2}>
        {t("status_sent")}
      </ColocaStatusPill>
    );
  }
  if (debit.status === "CANCELLED") {
    return (
      <ColocaStatusPill variant="neutral" icon={XCircle}>
        {t("status_cancelled")}
      </ColocaStatusPill>
    );
  }
  return isStaleReservation(debit) ? (
    <ColocaStatusPill variant="danger" icon={AlertTriangle}>
      {t("status_reserved_stale")}
    </ColocaStatusPill>
  ) : (
    <ColocaStatusPill variant="warning" icon={Clock}>
      {t("status_reserved")}
    </ColocaStatusPill>
  );
}
